<form [formGroup]="form">
  <div fxLayout="row">
    <div fxFlex="25">
      <h4 i18n>Customer Premises</h4>
      <mat-button-toggle-group formControlName="fiber_connections">
        <mat-button-toggle value="With PTO" i18n>WITH-OTO</mat-button-toggle>
        <mat-button-toggle value="Without PTO" i18n>WITHOUT-OTO</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <div fxFlex="25">
      <h4 *ngIf="form.value.fiber_connections ==='With PTO'" i18n>Drop-OTO</h4>
      <h4 *ngIf="form.value.fiber_connections !=='With PTO'" i18n>Drop-ONT</h4>
      <mat-button-toggle-group formControlName="connector" class="options">
        <mat-button-toggle value="factory_connector" i18n>FACTORY</mat-button-toggle>
        <mat-button-toggle value="field_connector" i18n>FIELD</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <div *ngIf="form.value.fiber_connections==='With PTO'" fxFlex="25">
      <h4 i18n>OTO-ONT</h4>
      <mat-button-toggle-group class="options" value="patch_cord">
        <mat-button-toggle value="patch_cord" i18n>PATCH CORD</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div>
</form>
